/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Registry } from "react-registry";
export var register = Component => {
  Registry.register(Component, Component.displayName);
};
export * from "react-registry";
